import React from "react";
import { Drawer, Divider } from "antd";
import { MenuOutlined, ContactsOutlined, FilterOutlined } from "@ant-design/icons";
import PropTypes from "prop-types";
import "../../../styles/MobileMenuDrawer.css"

export default function MobileMenuDrawer({
  visible,
  onClose,
  onContactClick,
  onFilterClick,
}) {
  return (
    <Drawer
      title={null}
      placement="left"
      onClose={onClose}
      open={visible}
      width={280}
      closeIcon={<MenuOutlined style={{ color: "#000", fontSize: 20 }} />}
      bodyStyle={{ padding: 0, backgroundColor: "#ffffff" }}
    >
      <div className="mpl-drawer-menu">
        <div className="mpl-drawer-item" onClick={onContactClick}>
          <ContactsOutlined style={{ marginRight: 12, fontSize: 18 }} />
          <span>Contacto</span>
        </div>
        <Divider style={{ margin: "8px 0" }} />
        <div
          className="mpl-drawer-item"
          onClick={() => {
            onClose();
            onFilterClick();
          }}
        >
          <FilterOutlined style={{ marginRight: 12, fontSize: 18 }} />
          <span>Filtros</span>
        </div>
      </div>
    </Drawer>
  );
}

MobileMenuDrawer.propTypes = {
  visible: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onContactClick: PropTypes.func.isRequired,
  onFilterClick: PropTypes.func.isRequired,
};
